import React, { useContext } from 'react';
import { AppContext } from 'context/AppContext';

const SelectedViewUserDetails = (props) => {
    let fontWeightBold = 'font-bold';

    let appContext = useContext(AppContext);

    // console.log(`appContext`, appContext.defaults);

    return (
        <div className="user-option-container">
            <div className="user-option">
                <div
                    onClick={() => props.setSelectToShowInformation('account')}
                    className={
                        props.selectToShowInformation === 'account'
                            ? fontWeightBold
                            : ''
                    }
                >
                    Account
                </div>
                {appContext.defaults.sub_is_active ? (
                    <div
                        onClick={() =>
                            props.setSelectToShowInformation('billing')
                        }
                        className={
                            props.selectToShowInformation === 'billing'
                                ? fontWeightBold
                                : ''
                        }
                    >
                        Billing
                    </div>
                ) : null}
                <div
                    onClick={() =>
                        props.setSelectToShowInformation('subscription')
                    }
                    className={
                        props.selectToShowInformation === 'subscription'
                            ? fontWeightBold
                            : ''
                    }
                >
                    Subscription
                </div>
            </div>
        </div>
    );
};

export default SelectedViewUserDetails;
